import React, { Fragment } from "react";
import { Box, Grid, Typography, Paper, useTheme } from "@mui/material";
import eventData from "./data.json";
import CenterLayout from "../../components/CenterLayout";
import LightModeIcon from "@mui/icons-material/LightMode";
import AlbumIcon from "@mui/icons-material/Album";
import NightlifeIcon from "@mui/icons-material/Nightlife";
import CampaignIcon from "@mui/icons-material/Campaign";
import LocalBarIcon from "@mui/icons-material/LocalBar";
import MicExternalOnIcon from "@mui/icons-material/MicExternalOn";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";

const icons = {
    activity: <LightModeIcon />,
    music: <AlbumIcon />,
    party: <NightlifeIcon />,
    announcement: <CampaignIcon />,
    bar: <LocalBarIcon />,
    singer: <MicExternalOnIcon />,
    food: <LocalDiningIcon />,
    mystery: <QuestionMarkIcon />,
};

const getCollision = (event) => {
    const { startTime, endTime } = event;
    if (new Date() < new Date(startTime)) return -1;
    if (new Date() > new Date(startTime) && new Date() < new Date(endTime)) return 0;
    if (new Date() > new Date(endTime)) return 1;
};

export default function Programme() {
    const theme = useTheme();
    return (
        <CenterLayout>
            {eventData.days
                .filter((day) => day.events.length)
                .map((day, index) => (
                    <Fragment key={index}>
                        <Typography variant="h4" sx={{ mb: 1 }}>
                            {day.dayName}
                        </Typography>
                        <Grid container spacing={1} sx={{ textAlign: "center" }}>
                            {day.events
                                .sort((a, b) => b.startTime - a.startTime)
                                .map((event, i) => (
                                    <Grid key={i} item xs={event.parallel ? 6 : 12}>
                                        <Paper
                                            sx={{
                                                p: 1,
                                                border:
                                                    getCollision(event) === 0
                                                        ? "1px solid " + theme.palette.primary.main
                                                        : "none",
                                                opacity: getCollision(event) === 1 ? 0.3 : 1,
                                            }}
                                        >
                                            <Typography variant="h5">{`${event.startTime.substring(
                                                11,
                                                16
                                            )}`}</Typography>
                                            <Box>{icons[event.type]}</Box>
                                            <Typography variant="button">{event.name}</Typography>
                                            <Typography>{event.location ? ` @ ${event.location}` : ""}</Typography>
                                        </Paper>
                                    </Grid>
                                ))}
                        </Grid>
                        <Box sx={{ height: 16 }} />
                    </Fragment>
                ))}
        </CenterLayout>
    );
}
